import React from 'react';
import { MdRefresh } from 'react-icons/md';

interface ButtonProps {
  variant?: keyof VariantStyles;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  isLoading?: boolean;
  width?: 'fit' | 'full';
  size?: 'sm' | 'md' | 'lg';
}

interface VariantStyles {
  primary: string;
  secondary: string;
  outlined: string;
  text: string;
}

const variantStyles: VariantStyles = {
  primary:
    'bg-primary text-neutralBG bg-primary hover:bg-primaryHover dark:bg-primary-dark dark:text-neutralBG dark:hover:bg-primaryHover-dark shadow-sm',
  secondary:
    'bg-secondary text-neutralText hover:bg-secondaryHover dark:bg-secondary-dark dark:text-neutralBG dark:hover:bg-secondaryHover-dark shadow-sm',
  outlined:
    'bg-transparent border border-neutralBG text-neutralText hover:bg-neutralBG hover:text-neutralBG-dark dark:border-neutralBG-dark dark:text-neutralBG-dark dark:hover:bg-neutralBG dark:hover:text-neutralBG',
  text: 'bg-transparent text-neutralText dark:text-neutralText-dark hover:opacity-80',
};

const sizeStyles = {
  sm: 'text-xs px-3 py-2',
  md: 'text-sm px-5 py-3',
  lg: 'text-lg px-7 py-4',
};

const widthStyles = {
  fit: 'w-fit',
  full: 'w-full',
};

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  onMouseEnter,
  onMouseLeave,
  disabled,
  className,
  startIcon,
  endIcon,
  type = 'button',
  variant = 'primary',
  isLoading,
  width = 'full',
  size = 'md',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disabled={disabled}
      className={`flex items-center justify-center gap-2 rounded-lg text-center font-medium transition-all duration-200 ${sizeStyles[size]} ${variantStyles[variant]} ${widthStyles[width]} ${className || ''}`}
    >
      {isLoading ? <MdRefresh className="animate-spin" /> : startIcon}
      {isLoading ? 'Chargement...' : children}
      {endIcon}
    </button>
  );
};
